import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Row,
  Form,
  Card,
  Modal,
  Spinner,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { vasthuUrl } from "../component/Api";
import BillDeskPay from "../component/BillDeskPay";
import Toast from "../component/Toast";
import { useTranslation } from "react-i18next";
import HelmetSeo from "../component/HelmetSeo";
import { UseConsultant } from "../context/ConsultantContext";

function WalletOffer(params) {
  const { walletBalance, setWalletBalance } = UseConsultant();
  const Navigate = useNavigate();
  const { t } = useTranslation();

  const lang = localStorage.getItem("i18nextLng");
  const token = sessionStorage.getItem("token");
  const role = sessionStorage.getItem("role");
  const crmUuid = params?.crmUuid;
  const userId =
    role === "ROLE_CRM" ? crmUuid : sessionStorage.getItem("userId");

  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState("Payment");
  const [transactionId, setTransactionId] = useState(null);
  const [paymentModal, setPaymentModal] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [selectedPrice, setSelectedPrice] = useState(null);

  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [toastTrigger, setToastTrigger] = useState(0);

  const alert = (msg) => {
    setMessage(msg);
    setToastTrigger((prev) => prev + 1);
  };

  const ClosePaymentModal = () => setPaymentModal(false);

  const OpenPaymentModal = (actualPrice, offerId) => {
    setPaymentModal(true);
    setSelectedOffer(offerId);
    setSelectedPrice(actualPrice);
  };

  const handleGetWalletBalance = () => {
    vasthuUrl
      .get(`/getuserbalance/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setWalletBalance(res.data.balance))
      .catch((e) => console.log("Wallet balance error", e));
  };

  useEffect(() => {
    vasthuUrl
      .get(`/getallactivewalletoffers`, {
        params: { userRole: role },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setOffers(res.data))
      .catch((error) => {
        console.error("SERVER ERROR", error);
        setOffers([]);
      });

    handleGetWalletBalance();
  }, [role, userId, token]);

  const handleProceedPayment = async () => {
    if (loading) return;
    setLoading(true);

    try {
      if (selectedOption === "Payment") {
        await handleBuy(selectedPrice, selectedOffer);
      } else if (selectedOption === "NonPayment") {
        await handleNonPayment();
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong!");
      setMessageType("error");
    } finally {
      setLoading(false);
    }
  };

  const handleBuy = async (actualPrice, offerId) => {
    try {
      const res = await vasthuUrl.post(
        `/openapi/createwalletorderapi`,
        {
          userUuid: userId,
          walletofferId: offerId,
          price: actualPrice,
          currency: "356",
          returnUrl: "customerpricing",
          lng: lang,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      BillDeskPay(res.data, BillDeskPayHandler)
        .then((config) => {
          window.loadBillDeskSdk(config);
          ClosePaymentModal();
        })
        .catch((err) => console.log("Payment initialization fails", err));
    } catch (err) {
      console.log("Buy error", err);
      alert("Payment initialization error");
      setMessageType("error");
    }
  };

  const handleNonPayment = async () => {
    if (!transactionId) {
      alert("Please enter a transaction ID");
      setMessageType("error");
      return;
    }

    try {
      await vasthuUrl.post(
        "/saveUserBalance",
        {
          userUuid: userId,
          walletofferId: selectedOffer,
          txnId: transactionId,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      alert("Payment successful!");
      setMessageType("success");
      ClosePaymentModal();

      setTimeout(() => {
        Navigate("/accounts");
      }, 2000);
    } catch (error) {
      console.error("Payment failed:", error);
      alert("Payment failed");
      setMessageType("error");
    }
  };

  const BillDeskPayHandler = (txn) => {
    vasthuUrl
      .post(
        "/user/bdpaymentresponseuiwallet",
        { txn: txn.txnResponse.transaction_response },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((res) => {
        if (res.data.transaction_error_type === "success") {
          vasthuUrl
            .post("/user/bdpaymentresponsehandlerwallet", txn, {
              headers: { Authorization: `Bearer ${token}` },
            })
            .then(() => {
              alert(t("USR.PAYMENT.MSG"));
              setMessageType("success");

              const returnurl = sessionStorage.getItem("returnurl");
              setTimeout(() => {
                setWalletBalance(0);
                if (role === "ROLE_CRM") {
                  Navigate("/accounts");
                } else if (role === "ROLE_USER") {
                  Navigate("/");
                } else {
                  Navigate(returnurl);
                  sessionStorage.removeItem("returnurl");
                }
              }, 2000);
            })
            .catch((err) => console.log("Save txn error", err));
        } else {
          alert("Payment failed");
          setMessageType("error");
        }
      });
  };

  const isDisabled =
    loading || (selectedOption === "NonPayment" && !transactionId);

  return (
    <>
      <Toast msg={message} type={messageType} trigger={toastTrigger} />
      <Container>
        <HelmetSeo
          title="Recharge Offers, Wallet & Discounts | Vasthuparam"
          name="description"
          content="Explore exclusive wallet offers and recharge discounts with Vasthuparam. Save more on every transaction with our special wallet rewards."
          relCa="canonical"
          hrefCa="https://www.vasthuparam.com/walletoffer"
          relAl="alternate"
          hrefAl="https://m.www.vasthuparam.com/walletoffer"
        />

        <div style={{ backgroundColor: "#ffc33b", marginTop: "5px" }}>
          <h3>
            <center>{t("USR.ADD.MONEY.WALT")}</center>
          </h3>
        </div>

        <Row style={{ marginTop: "15px" }}>
          <Col>
            <h2>
              <b>
                {t("USR.AVABLE.BALCE")}: ₹ {walletBalance}
              </b>
            </h2>
          </Col>
        </Row>

        <h4>
          <u>{t("USR.POPLR.RECHARGE")}</u>
        </h4>

        <Row>
          {offers.map((offer, index) => (
            <Col xs={4} sm={4} md={3} lg={2} key={offer.id}>
              <Card
                style={{
                  padding: "0",
                  borderRadius: "21px",
                  margin: "10px 0px",
                  border: "1px solid #ffc33b",
                  cursor: "pointer",
                  boxShadow:
                    "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 0px 2px 0 rgba(0, 0, 0, 0.19)",
                }}
                onClick={() =>
                  role === "ROLE_CRM"
                    ? OpenPaymentModal(offer.actualPrice, offer.id)
                    : handleBuy(offer.actualPrice, offer.id)
                }
                className="card-hover"
              >
                <Card.Body>
                  <Card.Text>
                    <center>₹ {offer.actualPrice}</center>
                  </Card.Text>
                </Card.Body>
                <div
                  style={{
                    backgroundColor: index === 0 ? "#3ee46d" : "#ffc33b",
                    padding: "5px",
                    borderBottomLeftRadius: "20px",
                    borderBottomRightRadius: "20px",
                  }}
                >
                  <center>
                    ₹ {offer.extraAmount} {t("USR.RECHARGE.EXTRA")}
                  </center>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      {/* Payment Modal */}
      <Modal
        className="all_border"
        show={paymentModal}
        onHide={ClosePaymentModal}
      >
        <Modal.Header className="all_background" closeButton>
          <Modal.Title>Payment Option</Modal.Title>
        </Modal.Header>

        <Row>
          <Col md={{ span: 6, offset: 3 }}>
            <div style={{ padding: "8px" }}>
              <Form.Check
                type="radio"
                label="Payment"
                name="PaymentOption"
                checked={selectedOption === "Payment"}
                onChange={() => setSelectedOption("Payment")}
              />
              <Form.Check
                type="radio"
                label="Non Payment"
                name="PaymentOption"
                checked={selectedOption === "NonPayment"}
                onChange={() => setSelectedOption("NonPayment")}
              />
              {selectedOption === "NonPayment" && (
                <Form.Group className="mt-3">
                  <Form.Label>Transaction Id</Form.Label>
                  <Form.Control
                    className="form_feild"
                    type="text"
                    placeholder="Enter the transaction id..."
                    value={transactionId || ""}
                    onChange={(e) => setTransactionId(e.target.value)}
                    autoComplete="off"
                  />
                </Form.Group>
              )}
            </div>
          </Col>
        </Row>

        <Modal.Footer>
          <Button
            className="all_btn"
            onClick={handleProceedPayment}
            disabled={isDisabled || loading}
          >
            {loading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />{" "}
                Processing...
              </>
            ) : (
              "Next"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default WalletOffer;
